import { FilterFieldConfig, renderFilterChip } from 'shared/mui/Filter/config';

type FilterChipsProps = {
  fields: FilterFieldConfig[];
};

export const FilterChips: React.FC<FilterChipsProps> = ({ fields }) => (
  <>{fields.map(renderFilterChip)}</>
);
